<template>
  <div id="app">
    <div v-if="$root.isLoading" class="loading">
      <div class="loading-box">

        <div class="loading-effect" style="top: 50%;left: 50%;">
          <div class="icon-button " :style="{ 'background-image': 'url(' + logo + ')' }"
            style="height: 3rem;width: 3rem;">
          </div>
        </div>
        <div class="loading-effect">
          <b-spinner style="width: 5rem; height: 5rem;" label="Large Spinner">

          </b-spinner>

        </div>
        <div class="loading-effect text-primary font-weight-900 mt-2" style="top: 80%;">
          {{ $t('loading...') }}

        </div>
      </div>
    </div>
    <Header v-if="showHeader"></Header>
    <router-view></router-view>
    <Footer></Footer>
    <errorMsg></errorMsg>
    <ForgetSecPassword></ForgetSecPassword>
  </div>
</template>

<script>
import errorMsg from './errorMsg.vue'
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import ForgetSecPassword from './views/sessions/forget-sec-password.vue'
export default {
  name: 'App',
  components: {
    errorMsg, Header, Footer, ForgetSecPassword
  },
  data() {
    return {
      logo: require('./assets/images/loading-icon.png')
    }
  },
  computed: {
    showHeader() {
      return !this.$route.path.includes('sessions') &&
             !this.$route.path.includes('set-sec-password')
    }
  },
  methods: {
    togglePassword(event, inputRef) {
      const input = this.$refs[inputRef];
      if (!input) return;

      const target = input.$el.querySelector('input'); // b-form-input is wrapped
      if (target.type === 'password') {
        target.type = 'text';
        event.target.src = require('./assets/images/action/hide.png'); // change to hide icon
      } else {
        target.type = 'password';
        event.target.src = require('./assets/images/action/show.png'); // change back to show icon
      }
    },
  },
  mounted() {
    this.$root.togglePassword = this.togglePassword;
    this.$root.getCountryList();
    this.$root.getGlobalSetting();
    var token = localStorage.getItem("currencyToken");
    if (token && token.length > 0) {
      this.$root.getInfo();
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
